<template>
  <section id="products" class="py-20 lg:py-32 bg-richBlack">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <!-- Section Header -->
      <div class="text-center mb-16 animate-fade-in-up">
        <h2 class="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-gold-gradient mb-4">
          مجموعتنا
        </h2>
        <div class="w-20 h-1 bg-gold-gradient mx-auto mb-6"></div>
        <p class="text-gray-300 text-lg max-w-2xl mx-auto">
          استكشف مجموعتنا الرائعة من المجوهرات الذهبية المصنوعة يدوياً، كل قطعة شاهد على
          الأناقة الخالدة والحرفية المتفوقة.
        </p>
      </div>

      <!-- Products Grid -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
        <ProductCard v-for="product in products" :key="product.id" :product="product" class="animate-fade-in-up"
          :style="{ animationDelay: `${product.id * 0.1}s` }" />
      </div>
    </div>
  </section>
</template>

<script setup>
import { useProducts } from '@/composables/useProducts'
import ProductCard from './ProductCard.vue'

// Get products from composable
const { products } = useProducts()
</script>
